import React from 'react'
import tw, { styled } from 'twin.macro'


export default styled.div`
  ${tw`container`}
`